import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import HeaderPage from './header/Header';
import LeftPanel from './LeftPanel';
class MainPage extends Component {
  render() {
    return (
      <div>
        <div id="navBar">
          <HeaderPage />
        </div>
        <div className="content-wrapper" id="leftPanel" >
          <Route path='/projectmgmt' component={LeftPanel}></Route>
        </div>
      </div>
    );
  }
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/sales-desk/MainPage.js